export const departments = '/departments';
